import * as PIXI from 'pixi.js';
import Config from './Config';

export default class Ground extends PIXI.Container {
  constructor() {
    super();
    this.sprite = null;
    this.position.set(Config.GAME_WIDTH / 2, Config.GAME_HEIGHT - Config.GROUND_HEIGHT);
    // this.graphics = new PIXI.Graphics();

    // this.graphics.beginFill(0xff0000);
    // this.graphics.drawRect(-Config.GAME_WIDTH / 2, 0, Config.GAME_WIDTH, Config.GROUND_HEIGHT);
    // this.graphics.endFill();
    // this.addChild(this.graphics);
  }

  onResourcesLoaded() {
    const { texture } = PIXI.Loader.shared.resources['ground'];

    this.sprite = new PIXI.TilingSprite(texture, Config.GAME_WIDTH, texture.height);
    this.sprite.anchor.set(0.5, 1);
    this.sprite.position.set(0, Config.GROUND_HEIGHT);

    this.addChild(this.sprite);
  }

  update(dt, [
    background,
    foreground,
    player,
    ground,
    ...treasures
  ], viewport) {
    if (!this.sprite) return;

    this.sprite.tilePosition.x = -player.positionX % this.sprite.texture.width;
  }
}
